import React, { Fragment, useRef } from 'react';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import './SwipeableView.css';
import Button from 'components/atoms/Button/Button';
import Division from 'components/atoms/Division/Division';
import { useTranslation } from 'react-i18next';

export default function SwipeableView(props) {
  const { children, id } = props;
  const { t } = useTranslation();

  const swiperRef = useRef(null);
  const goToNextSwipeableItem = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const params = {
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"></span>';
      },
    },
  };

  return (
    <Fragment>
      <Division id={id} style={{ paddingBottom: '12px' }}>
        <Swiper {...params} ref={swiperRef} rebuildOnUpdate={true}>
          {children &&
            children.map((item, ix) => (
              <Division key={`${id}-${ix}`}>{item}</Division>
            ))}
        </Swiper>
        <Division style={{ display: 'flex', justifyContent: 'center' }}>
          <Button onClick={goToNextSwipeableItem}>
            {t('dna24.menu.showMeAnother')}
          </Button>
        </Division>
      </Division>
    </Fragment>
  );
}
